// extracted by mini-css-extract-plugin
export default {"subjectFormContainer":"SubjectForm_subjectFormContainer__tmh4O","form":"SubjectForm_form__w68fU","group":"SubjectForm_group__q1W7H","error":"SubjectForm_error__NjZTn"};